import { render, staticRenderFns } from "./TgPurchase.vue?vue&type=template&id=718a0a32&"
import script from "./TgPurchase.vue?vue&type=script&lang=js&"
export * from "./TgPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports